import { render, staticRenderFns } from "./MyCasesProductTile.vue?vue&type=template&id=10fb719c&"
import script from "./MyCasesProductTile.vue?vue&type=script&lang=js&"
export * from "./MyCasesProductTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports